import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {
	transform(tel: any, args?: any): string {
		try {
			if (typeof tel !== 'string' && typeof tel !== 'number') {
				return '';
			}
	
			const value = String(tel).trim().replace(/^\+/, '').replace(/-/g, '');
	
			// Early return if non-digit characters remain
			if (!/^\d+$/.test(value)) {
				return String(tel);
			}
	
			let country = '';
			let city = '';
			let number = '';
	
			switch (value.length) {
			case 10:
				country = '1';
				city = value.slice(0, 3);
				number = value.slice(3);
				break;
	
			case 11:
				country = value[0];
				city = value.slice(1, 4);
				number = value.slice(4);
				break;
	
			case 12:
				country = value.slice(0, 3);
				city = value.slice(3, 5);
				number = value.slice(5);
				break;
	
			default:
				return String(tel); // unsupported format
			}
	
			// Only show country code if not US
			const displayCountry = country !== '1' ? `${country} ` : '';
	
			// Split number part into 3-4 if possible
			if (number.length >= 7) {
				number = number.slice(0, 3) + '-' + number.slice(3);
			}
	
			return `${displayCountry}(${city}) ${number}`.trim();
		} catch (err) {
			console.error('Phone transform error:', err);
			return String(tel);
		}
	}
}
